import React, { FC } from 'react'

import { BrandOverlay } from '@Components/Brand/BrandOverlay'
import { ImageV2 } from '@Components/Image'
import { Link } from '@Components/Link'
import { Brand } from '@Generated/graphql'

import styles from './CollectionItem.module.scss'

interface CollectionItemProps {
  brand?: Brand
  id: string
  imageURL: string
  large?: boolean
  link: string
  title: string
}

export const CollectionItem: FC<CollectionItemProps> = ({
  brand,
  id,
  imageURL,
  large,
  link,
  title,
}: CollectionItemProps) => (
  <Link
    analytics={{
      dest_page_type: 'collections',
      dest_page_type_id: id,
      source_id: 'side_bar',
    }}
    className={styles.collectionItemContainer}
    href={link}
  >
    {imageURL && (
      <BrandOverlay brand={brand}>
        <ImageV2
          key={id}
          alt={title}
          height={large ? '169' : '126'}
          src={imageURL}
          width={large ? '282' : '210'}
        />
      </BrandOverlay>
    )}
    <span className={styles.itemTitle}>{title}</span>
  </Link>
)
